import PropTypes from 'prop-types'
import { sliceStatusPropTypes } from '../slice.types'

/**
 * @typedef {Object} CheckoutTaxSliceState
 * @property {import('../slice.types').SliceStatus} status
 * @property {import('../slice.types').SliceError[]} errors
 * @property {number} taxQuoteCents
 * @property {any} taxQuoteData
 */

/** @type {CheckoutTaxSliceState} */
export const initialCheckoutTaxState = {
  status: 'init',
  errors: [],
  taxQuoteCents: 0,
  taxQuoteData: null
}

/** @enum {string} */
export const CHECKOUT_TAX_ACTIONS = {
  SET_STATUS: 'CHECKOUT_TAX/SET_STATUS',
  SET_ERRORS: 'CHECKOUT_TAX/SET_ERRORS',
  CLEAR_ERRORS: 'CHECKOUT_TAX/CLEAR_ERRORS',
  SET_TAX_QUOTE: 'CHECKOUT_TAX/SET_TAX_QUOTE'
}

export const checkoutTaxSlicePropType = PropTypes.shape({
  status: sliceStatusPropTypes,
  errors: PropTypes.arrayOf(PropTypes.shape({ message: PropTypes.string })),
  taxQuoteCents: PropTypes.number,
  taxQuoteData: PropTypes.any
})
